<template>
    <div>
      <mcheader ref="mcheader"></mcheader>
     <div>
       <div class="slider-wrap">
         <div class="preview-2">
           <div id="nivoslider" class="slides" >
             <!--<img src="http://47.97.180.196:9999/imgs/4338810964d811e997d200163e0e7135.png" alt="">-->
               <img v-for="(item,i) in rotationChart" :index="i" :key="i" :src="item.imgUrl" alt="" >
           </div>
           <!-- direction 1 -->
           <div id="slider-direction-1" class="t-cn slider-direction">
             <div class="nivo_text">
               <div class="slider-content slider-text-1">
                 <div class="wow bounceInDown" data-wow-duration="3s" data-wow-delay="0.3s">
                   <h4>Summer Collection</h4>
                 </div>
               </div>
               <div class="slider-content slider-text-2">
                 <div class="wow bounceInLeft" data-wow-duration="3s" data-wow-delay="1s">
                   <h1 class="title">FOR MEN - 2016</h1>
                 </div>
               </div>
               <div class="slider-content slider-text-3">
                 <div class="wow bounceInUp" data-wow-duration="3s" data-wow-delay="1s">
                   <a href='#' class='slider-button'>Shop Now <i class="fa fa-angle-right"></i></a>
                 </div>
               </div>
             </div>
           </div>
           <!-- direction 2 -->
           <div id="slider-direction-2" class="slider-direction">
             <div class="nivo_text slide_two">
               <div class="slider-content slider-text-1">
                 <div class="wow bounceInDown" data-wow-duration="2s" data-wow-delay="0.3s">
                   <h4>Summer Collection</h4>
                 </div>
               </div>
               <div class="slider-content slider-text-2">
                 <div class="wow bounceInRight" data-wow-duration="3s" data-wow-delay="1s">
                   <h1 class="title">FOR WOMEN - 2016</h1>
                 </div>
               </div>
               <div class="slider-content slider-text-3">
                 <div class="wow bounceInUp" data-wow-duration="3s" data-wow-delay="1s">
                   <a href='#' class='slider-button'>Shop Now <i class="fa fa-angle-right"></i></a>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
       <!--<div class="service_area clearfix">-->
         <!--<div class="single-service">-->
           <!--<div class="service-icon">-->
             <!--<img src="./assets/img/icon/1.png" alt="">-->
           <!--</div>-->
           <!--<div class="service-info">-->
             <!--<h2><a href="#">Free Shipping</a></h2>-->
             <!--<p>Free for all product</p>-->
           <!--</div>-->
         <!--</div>-->
         <!--<div class="single-service">-->
           <!--<div class="service-icon">-->
             <!--<img src="./assets/img/icon/2.png" alt="">-->
           <!--</div>-->
           <!--<div class="service-info">-->
             <!--<h2><a href="#">Order Online</a></h2>-->
             <!--<p><a href="www.bootexperts.com">www.bootexperts.com</a></p>-->
           <!--</div>-->
         <!--</div>-->
         <!--<div class="single-service hidden-sm">-->
           <!--<div class="service-icon">-->
             <!--<img src="./assets/img/icon/3.png" alt="">-->
           <!--</div>-->
           <!--<div class="service-info">-->
             <!--<h2><a href="#">Money Back</a></h2>-->
             <!--<p>Money back guarantee</p>-->
           <!--</div>-->
         <!--</div>-->
         <!--<div class="single-service hidden-sm hidden-md">-->
           <!--<div class="service-icon">-->
             <!--<img src="./assets/img/icon/4.png" alt="">-->
           <!--</div>-->
           <!--<div class="service-info">-->
             <!--<h2><a href="#">Gift Coupon</a></h2>-->
             <!--<p>Surprise gift coupon</p>-->
           <!--</div>-->
         <!--</div>-->
       <!--</div>-->
       <!-- service end -->
       <!-- banner start -->
       <div class="banner-area clearfix">
         <div class="single-banner" v-for="(item, index) in categories " :key="index" @click="goproduct(item)">
           <a  class="border-hover"><img :src="item.imgUrl" alt=""  ></a>
           <a  class='slider-button' >Shop Now <i class="fa fa-angle-right"></i></a>
         </div>

       </div>
       <!-- banner end -->
       <!-- arrival start -->
       <div class="arrival-area clearfix">
         <div class="container">
           <div class="row">
             <div class="col-xs-12">
               <div class="section-tab" v-show="true">
                 <!--<div class="section-tab-menu text-left">-->
                   <!--<ul role="tablist">-->
                     <!--<li role="presentation" class="active"><a href="#new" aria-controls="new" role="tab" data-toggle="tab">New Arrival</a></li>-->
                     <!--<li role="presentation"><a href="#featured" aria-controls="featured" role="tab" data-toggle="tab">Featured</a></li>-->
                     <!--<li role="presentation"><a href="#best" aria-controls="best" role="tab" data-toggle="tab">Best Selling</a></li>-->
                   <!--</ul>-->
                 <!--</div>-->
                 <div class="clearfix"></div>
                 <div class="tab-content row" :id="item.id" v-for="(item,index) in oneList" v-if="true" :key="index">
                   <div class=""  role="tabpanel" v-bind:class="'section-tab-item' + item.active" >
                     <div class="tab-item-slider">
                       <div class="col-xs-12 col-width"  v-for="(chieItem,index1) in item.chillie"  :key="index1" @click="goDeatil(chieItem)">
                         <div class="single-product">
                           <div class="single-product-item">
                             <div class="single-product-img clearfix hover-effect">
                               <a>
                                 <img class="primary-image" :src="chieItem.img_url" alt="">
                               </a>
                             </div>
                             <div class="single-product-info clearfix">
                             <div class="pro-rating">
                               <i class="fa fa-star"></i>
                               <i class="fa fa-star"></i>
                               <i class="fa fa-star"></i>
                               <i class="fa fa-star"></i>
                               <i class="fa fa-star"></i>
                             </div>
                             <div class="pro-price">
                               <span class="new-price">{{chieItem.price}}</span>
                               <span class="old-price">{{chieItem.orig_price}}</span>
                             </div>
                             <h3><a href="">{{chieItem.name}}</a></h3>
                           </div>
                             <div class="wish-icon-hover text-center" >
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="section-button text-center">
                 <a href='#' class='slider-button'>View More <i class="fa fa-angle-right"></i></a>
               </div>
             </div>
           </div>
         </div>
       </div>
       <!-- arrival end -->
       <!-- featured start -->
       <div class="featured-area clearfix">
         <div class="container">

         </div>
       </div>
       <!-- featured end -->
       <!-- big banner start -->
       <!--<div class="big_banner-area clearfix">-->
         <!--<div class="single-big-banner">-->
           <!--<a href="#" class="border-hover"><img src="./assets/img/banner/big2.jpg" alt=""></a>-->
           <!--<div class="section-button text-center">-->
             <!--<a href='#' class='slider-button'>View More <i class="fa fa-angle-right"></i></a>-->
           <!--</div>-->
         <!--</div>-->
         <!--<div class="single-big-banner">-->
           <!--<a href="#" class="border-hover"><img src="./assets/img/banner/big3.jpg" alt=""></a>-->
           <!--<div class="section-button text-center section-button-two">-->
             <!--<a href='#' class='slider-button'>View More <i class="fa fa-angle-right"></i></a>-->
           <!--</div>-->
         <!--</div>-->
       <!--</div>-->
       <!-- big banner end -->
       <!-- trendy start -->

       <!-- trendy end -->
       <!-- blog start -->
       <div class="from-blog-area">
         <div class="container">
           <div class="row">
             <div class="col-xs-12">
               <div class="section-title">
                 <h4>From the blog</h4>
               </div>
             </div>
           </div>
           <div class="row blog-margin">
             <div class="col-md-4">
               <div class="single-from-blog">
                 <div class="from-blog-text">
                   <h5><a href="#">Dress for cute girl fashion</a></h5>
                   <h6>February 6th, 2016, 12.45pm</h6>
                   <p>But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete</p>
                   <div class="button-comments">
                     <div class="section-button text-center">
                       <a href='#' class='slider-button'>More <i class="fa fa-angle-right"></i></a>
                     </div>
                     <div class="comment-like">
                       <ul>
                         <li><i class="fa fa-comments"></i>12 comments</li>
                         <li><i class="fa fa-heart"></i>50 likes</li>
                       </ul>
                     </div>
                   </div>
                 </div>
                 <div class="from-blog-img">
                   <a href="#" class="border-hover">
                     <img src="./assets/img/blog/from1.jpg" alt="">
                   </a>
                 </div>
               </div>
             </div>
             <div class="col-md-4">
               <div class="single-from-blog">
                 <div class="from-blog-img">
                   <a href="#" class="border-hover">
                     <img src="./assets/img/blog/from2.jpg" alt="">
                   </a>
                 </div>
                 <div class="from-blog-text">
                   <h5><a href="#">Men's New Fashion Style</a></h5>
                   <h6>February 6th, 2016, 12.45pm</h6>
                   <p>But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete</p>
                   <div class="button-comments">
                     <div class="section-button text-center">
                       <a href='#' class='slider-button'>More <i class="fa fa-angle-right"></i></a>
                     </div>
                     <div class="comment-like">
                       <ul>
                         <li><i class="fa fa-comments"></i>06 comments</li>
                         <li><i class="fa fa-heart"></i>25 likes</li>
                       </ul>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             <div class="col-md-4">
               <div class="single-from-blog">
                 <div class="from-blog-text">
                   <h5><a href="#">Fashion Show With New Trend</a></h5>
                   <h6>February 25th, 2016, 10.15am</h6>
                   <p>But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete</p>
                   <div class="button-comments">
                     <div class="section-button text-center">
                       <a href='#' class='slider-button'>More <i class="fa fa-angle-right"></i></a>
                     </div>
                     <div class="comment-like">
                       <ul>
                         <li><i class="fa fa-comments"></i>06 comments</li>
                         <li><i class="fa fa-heart"></i>25 likes</li>
                       </ul>
                     </div>
                   </div>
                 </div>
                 <div class="from-blog-img">
                   <a href="#" class="border-hover">
                     <img src="./assets/img/blog/from3.jpg" alt="">
                   </a>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
       <div class="from-blog-area">
         <div class="container">
           <div class="section-title">
             <h4>From the instagram</h4>
           </div>
           <iframe src="https://www.mocalilie.com/imgs/ins.html" width="100%" height="550px" scrolling="no" frameborder="0">

           </iframe>
         </div>
       </div>
       <!-- blog end -->
       <!-- testimonial start -->
       <!--<div class="testimonal-area">-->
         <!--<div class="container-fluid" >-->
           <!--<div class="row">-->
             <!--<div class="col-md-7 testimonal-right col-md-offset-5">-->
               <!--<div class="testimonal-total">-->
                 <!--<div class="testimonial-owl-wrap">-->
                   <!--<div class="single-testimonial">-->
                     <!--<div class="testimonial-img">-->
                       <!--<a href="#"><img src="../static/testimonial/1.jpg" alt=""></a>-->
                     <!--</div>-->
                     <!--<div class="testimonial-info">-->
                       <!--<h5>Zaculine Jenelia, <span>Head Of Business</span></h5>-->
                       <!--<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation </p>-->
                     <!--</div>-->
                   <!--</div>-->
                   <!--<div class="single-testimonial">-->
                     <!--<div class="testimonial-img">-->
                       <!--<a href="#"><img src="../static/testimonial/1.jpg" alt=""></a>-->
                     <!--</div>-->
                     <!--<div class="testimonial-info">-->
                       <!--<h5>Zaculine Jenelia, <span>Head Of Business</span></h5>-->
                       <!--<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation </p>-->
                     <!--</div>-->
                   <!--</div>-->
                   <!--<div class="single-testimonial">-->
                     <!--<div class="testimonial-img">-->
                       <!--<a href="#"><img src="../static/testimonial/1.jpg" alt=""></a>-->
                     <!--</div>-->
                     <!--<div class="testimonial-info">-->
                       <!--<h5>Zaculine Jenelia, <span>Head Of Business</span></h5>-->
                       <!--<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation </p>-->
                     <!--</div>-->
                   <!--</div>-->
                 <!--</div>-->
               <!--</div>-->
               <!--<div class="section-button text-center">-->
                 <!--<a href='#' class='slider-button'>View More <i class="fa fa-angle-right"></i></a>-->
               <!--</div>-->
             <!--</div>-->
           <!--</div>-->
         <!--</div>-->
       <!--</div>-->
       <!-- testimonial end -->
       <!-- client start -->

        <mcfoot ref="mcfoot"></mcfoot>
       <!-- footer end -->

       <!-- QUICKVIEW PRODUCT -->
       <div id="quickview-wrapper">
         <!-- Modal -->
         <div :class="modal" id="productModal">
           <div class="modal-dialog" role="document">
             <div class="modal-content">
               <div class="modal-header">
                 <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
               </div>
               <div class="modal-body">
                 <div class="modal-product">
                   <div class="product-images">
                     <div class="main-image images">
                       <img alt="" src="img/product/static2.jpg">
                     </div>
                   </div><!-- .product-images -->

                   <div class="product-info">
                     <h1>Diam quis cursus</h1>
                     <div class="price-box">
                       <p class="price"><span class="special-price"><span class="amount">$132.00</span></span></p>
                     </div>
                     <a href="shop.html" class="see-all">See all features</a>
                     <div class="quick-add-to-cart">
                       <form method="post" class="cart">
                         <div class="numbers-row">
                           <input type="number" id="french-hens" value="3">
                         </div>
                         <button class="single-add-to-cart-button" type="submit">Add to cart</button>
                       </form>
                     </div>
                     <div class="quick-desc">
                       Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam fringilla augue nec est tristique auctor. Donec non est at libero vulputate rutrum.
                     </div>
                     <div class="social-sharing">
                       <div class="widget widget_socialsharing_widget">
                         <h3 class="widget-title-modal">Share this product</h3>
                         <ul class="social-icons">
                           <li><a target="_blank" title="Facebook" href="#" class="facebook social-icon"><i class="fa fa-facebook"></i></a></li>
                           <li><a target="_blank" title="Twitter" href="#" class="twitter social-icon"><i class="fa fa-twitter"></i></a></li>
                           <li><a target="_blank" title="Pinterest" href="#" class="pinterest social-icon"><i class="fa fa-pinterest"></i></a></li>
                           <li><a target="_blank" title="Google +" href="#" class="gplus social-icon"><i class="fa fa-google-plus"></i></a></li>
                           <li><a target="_blank" title="LinkedIn" href="#" class="linkedin social-icon"><i class="fa fa-linkedin"></i></a></li>
                         </ul>
                       </div>
                     </div>
                   </div><!-- .product-info -->
                 </div><!-- .modal-product -->
               </div><!-- .modal-body -->
             </div><!-- .modal-content -->
           </div><!-- .modal-dialog -->
         </div>
         <!-- END Modal -->
       </div>
     </div>

      <router-view/>
    </div>
</template>

<script>
import mcheader from '@/components/Mcheader'
import mcfoot from '@/components/Mcfoot'
import https from './js/https.js'

export default {
  name: 'home',
  components:
    {
      mcheader,
      mcfoot
    },
  data () {
    return {
      aaa: '',
      oneList: [
        {
          id: 'new',
          chillie: [
            // {
            //   title: 'Tletria Ostma',
            //   imgsrc: require('../static/product/1.jpg'),
            //   newPrice: '$150',
            //   oldPrice: '$180'
            // }, {
            //   title: 'Electria postma',
            //   imgsrc: require('../static/product/2.jpg'),
            //   newPrice: '$130',
            //   oldPrice: '$150'
            // }, {
            //   title: 'Electria postma',
            //   imgsrc: require('../static/product/3.jpg'),
            //   newPrice: '$130',
            //   oldPrice: '$150'
            // }, {
            //   title: 'Electria postma',
            //   imgsrc: require('../static/product/4.jpg'),
            //   newPrice: '$130',
            //   oldPrice: '$150'
            // }, {
            //   title: 'Electria postma',
            //   imgsrc: require('../static/product/5.jpg'),
            //   newPrice: '$130',
            //   oldPrice: '$150'
            // }, {
            //   title: 'Electria postma',
            //   imgsrc: require('../static/product/6.jpg'),
            //   newPrice: '$130',
            //   oldPrice: '$150'
            // }, {
            //   title: 'Electria postma',
            //   imgsrc: require('../static/product/7.jpg'),
            //   newPrice: '$130',
            //   oldPrice: '$150'
            // }
          ],
          active: 'active'
        }
        // {
        //   id: 'feat',
        //   chillie: [
        //     {
        //       title: 'Tletria Ostma',
        //       imgsrc: require('../static/product/2.jpg'),
        //       newPrice: '$150',
        //       oldPrice: '$180'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/2.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/2.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/2.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/5.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/6.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/7.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }
        //   ],
        //   active: ''
        // },
        // {
        //   id: 'best',
        //   chillie: [
        //     {
        //       title: 'Tletria Ostma',
        //       imgsrc: require('../static/product/3.jpg'),
        //       newPrice: '$150',
        //       oldPrice: '$180'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/3.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/3.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/4.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/3.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/6.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }, {
        //       title: 'Electria postma',
        //       imgsrc: require('../static/product/7.jpg'),
        //       newPrice: '$130',
        //       oldPrice: '$150'
        //     }
        //   ],
        //   active: ''
        // }
      ],
      twoList: [
        {
          id: 'women',
          chillie: [
            {
              title: 'Tletria Ostma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$150',
              oldPrice: '$180'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }
          ],
          active: ''
        }, {
          id: 'men',
          chillie: [
            {
              title: 'Tletria Ostma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$150',
              oldPrice: '$180'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }
          ],
          active: ''
        }, {
          id: 'acc',
          chillie: [
            {
              title: 'Tletria Ostma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$150',
              oldPrice: '$180'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }
          ],
          active: ''
        }
      ],
      threeList: [
        {
          id: 'women-two',
          chillie: [
            {
              title: 'Tletria Ostma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$150',
              oldPrice: '$180'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }
          ],
          active: 'active'
        }, {
          id: 'men-two',
          chillie: [
            {
              title: 'Tletria Ostma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$150',
              oldPrice: '$180'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }
          ],
          active: ''
        }, {
          id: 'acc-two',
          chillie: [
            {
              title: 'Tletria Ostma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$150',
              oldPrice: '$180'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }, {
              title: 'Electria postma',
              imgsrc: 'https://inews.gtimg.com/newsapp_bt/0/10106832026/1000',
              newPrice: '$130',
              oldPrice: '$150'
            }
          ],
          active: ''
        }
      ],
      rotationChart: [],
      categories: [],
      productModal: '',
      modal: 'modal'
    }
  },
  methods: {
    setDate () {
    },
    getFirst () {
    },
    getPicture () {
      var userid = sessionStorage.getItem('userId')
      console.log(userid)
      // 获取推荐产品
      https.fetchGet('mocalilie/api/rotationChart', {
        // 传递的参数
      }).then((res) => {
        console.log(res.data.data)
        // 获取的参数
        this.rotationChart = res.data.data
        this.$nextTick(function () {
          $('#nivoslider').nivoSlider({
            effect: 'random', // 设置幻灯变化效果
            slices: 15, // 动画效果参数
            boxCols: 8, // box动画效果参数
            boxRows: 4, // 动画效果参数
            animSpeed: 500,
            pauseTime: 5000,
            startSlide: 0,
            directionNav: true,
            directionNavHide: true,
            controlNavThumbs: true,
            prevText: '<',
            nextText: '>',
            pauseOnHover: false,
            manualAdvance: false
          })
        })
        console.log(this.oneList[0])
      })
      // 获取分类
      https.fetchGet('mocalilie/api/categories', {
      }).then((res) => {
        console.log(res.data.data)
        this.categories = res.data.data
      })
    //   var url = 'mocalilie/api/rotationChart'
    //   this.$axios({
    //     method: 'get',
    //     url: url,
    //     data: {}
    //   }).then(function (res) {
    //     console.log(res)
    //   }).catch(function (err) {
    //     console.log(err)
    //   })
    },
    gethotProduct () {
      https.fetchGet('mocalilie/api/products/queryHot', {
      }).then((res) => {
        console.log(res.data.data)
        this.oneList[0].chillie = res.data.data
        this.$nextTick(function () { // ==》更新dom后，执行轮播
          // $('.tab-item-slider').owlCarousel({
          //   autoPlay: false,
          //   slideSpeed: 2000,
          //   pagination: false,
          //   navigation: true,
          //   items: 5,
          //   /* transitionStyle : "fade", */ /* [This code for animation ] */
          //   navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          //   itemsDesktop: [1199, 4],
          //   itemsDesktopSmall: [980, 3],
          //   itemsTablet: [768, 2],
          //   itemsMobile: [479, 1]
          // })

          // $('.trend-item-slider').owlCarousel({
          //   autoPlay: false,
          //   slideSpeed: 2000,
          //   pagination: false,
          //   navigation: true,
          //   items: 3,
          //   /* transitionStyle : "fade", */ /* [This code for animation ] */
          //   navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          //   itemsDesktop: [1199, 2],
          //   itemsDesktopSmall: [980, 2],
          //   itemsTablet: [768, 2],
          //   itemsMobile: [479, 1]
          // })
          $('.related-product-wrapper').owlCarousel({
            autoPlay: false,
            slideSpeed: 2000,
            pagination: false,
            navigation: true,
            items: 6,
            /* transitionStyle : "fade", */ /* [This code for animation ] */
            navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            itemsDesktop: [1399, 5],
            itemsDesktopSmall: [980, 3],
            itemsTablet: [768, 2],
            itemsMobile: [479, 1]
          })
          $('.testimonial-owl-wrap').owlCarousel({
            autoPlay: false,
            slideSpeed: 2000,
            pagination: false,
            navigation: true,
            items: 1,
            /* transitionStyle : "fade", */ /* [This code for animation ] */
            navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            itemsDesktop: [1399, 1],
            itemsDesktopSmall: [980, 1],
            itemsTablet: [768, 1],
            itemsMobile: [479, 1]
          })
          $('.tab-item-slider-two').owlCarousel({
            autoPlay: false,
            slideSpeed: 2000,
            pagination: false,
            navigation: true,
            items: 5,
            /* transitionStyle : "fade", */ /* [This code for animation ] */
            navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            itemsDesktop: [1399, 3],
            itemsDesktopSmall: [980, 3],
            itemsTablet: [768, 2],
            itemsMobile: [479, 1]
          })
          // $('.tab-item-slider').owlCarousel({
          //   autoPlay: false,
          //   slideSpeed: 2000,
          //   pagination: false,
          //   navigation: true,
          //   items: 5,
          //   /* transitionStyle : "fade", */ /* [This code for animation ] */
          //   navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          //   itemsDesktop: [1199, 4],
          //   itemsDesktopSmall: [980, 3],
          //   itemsTablet: [768, 2],
          //   itemsMobile: [479, 1]
          // })
          $('#slider-range').slider({
            range: true,
            min: -80,
            max: 460,
            values: [ 25, 325 ],
            slide: function (event, ui) {
              $('#amount').val('$' + ui.values[ 0 ] + ' - $' + ui.values[ 1 ])
            }
          })
          $('#amount').val('$' + $('#slider-range').slider('values', 0) +
            ' - £' + $('#slider-range').slider('values', 1))

          this.$refs.mcheader.getsecond()
          console.log('aaa')
        })
      })
    },
    showModal (e, index1) {
      console.log(index1)
      console.log(e)
      this.productModal = '#productModal'
      this.modal = 'modal'
    },
    // 跳转到产品详情页
    goDeatil (i) {
      this.$router.push({
        name: 'detail',
        query: {
          productId: i.id
        }
      })
    },
    goproduct (i) {
      this.$router.push({
        name: 'shoplist',
        query: {
          id: i.id
        }
      })
    }
  },
  created () {
    this.getFirst()
    this.getPicture()
    this.gethotProduct()
  },
  mounted () {
    this.setDate()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/home.vue